import { lazyForPaint } from 'react-loosely-lazy';
const LazyPricingTab = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-pricing-tab" */'./PricingTab').then(module => module.default));
export default LazyPricingTab;